// Final 3-month engagement report — Mar 24 → Jul 7, 2026
// Sources:
//  - Apify rescrape Jul 7, 2026 (clients-current/abhiveer/research/data/, scrape-jul7.log):
//    main-ig, main-yt, masked-ig, masked-yt, masked-tt = FRESH.
//  - unseen-yt + labs-yt refreshed Jul 7 via yt-dlp shorts-tab dump (full channel, no cap):
//    both channels are network-branded with no pre-window content, so lifetime = in-window.
//  - unseen-ig (302 posts), labs-ig (305), unseen-tt, labs-tt re-scraped Jul 7 with the
//    fresh Apify key, FULL profile history (400-post limit, no truncation).
//  - All numbers are measured public views.

export const WINDOW = {
    label: 'Mar 24 to Jul 7, 2026',
    days: 105,
    badge: 'Final 3-Month Network Report',
};

// May 13 snapshot (previous report) — for the Then vs Now section
export const MAY_SNAPSHOT = {
    label: 'May 13 report',
    views: 536405,
    posts: 595,
    followers: 5115,
};

export const TOTALS = {
    views: 1193611,
    posts: 2134,
    followers: 6477,
    activeAccounts: 11,
    accountCount: 11,
    platformCount: 3,
    avgViewsPerPost: 559,
    topAccount: { handle: '@unseenabhiveer', platform: 'Instagram', views: 598481 },
};

export const MAIN = {
    ig: { platform: 'Instagram', handle: '@themaskwithabhiveer', followers: 4545, posts: 177, views: 450828, status: 'live' },
    yt: { platform: 'YouTube', handle: '@themaskwithabhiveer', subscribers: 816, posts: 149, views: 77068, status: 'live' },
    tt: { platform: 'TikTok', handle: '@themaskwithabhiveer', followers: null, posts: null, views: null, status: 'pending' },
};

export const FAN_PAGES = [
    { persona: 'Unseen', platform: 'Instagram', handle: '@unseenabhiveer', followers: 1075, posts: 302, views: 598481 },
    { persona: 'Unseen', platform: 'YouTube', handle: '@UnseenAbhiveer', followers: 13, posts: 314, views: 12018 },
    { persona: 'Unseen', platform: 'TikTok', handle: '@unseenabhiveer', followers: 0, posts: 120, views: 3 },
    { persona: 'Masked', platform: 'Instagram', handle: '@themaskedabhi', followers: 15, posts: 180, views: 16468 },
    { persona: 'Masked', platform: 'YouTube', handle: '@TheMaskedAbhi', followers: 1, posts: 65, views: 57 },
    { persona: 'Masked', platform: 'TikTok', handle: '@themaskedabhi', followers: 0, posts: 90, views: 1 },
    { persona: 'Labs', platform: 'Instagram', handle: '@abhiveerlabs', followers: 12, posts: 305, views: 38445 },
    { persona: 'Labs', platform: 'YouTube', handle: '@abhiveerlabs', followers: 0, posts: 312, views: 242 },
    { persona: 'Labs', platform: 'TikTok', handle: '@abhiveerlabs', followers: 0, posts: 120, views: 0 },
];

export const STALE_NOTE = 'All 11 accounts fully re-measured on Jul 7, 2026 with complete profile history. All figures are measured public views.';

// Views earned by content PUBLISHED in each period, measured Jul 7 (dated posts;
// excludes 12,260 undated YouTube views). Early-window counts are floors.
export const MONTHS = [
    { label: 'Mar 24 – Apr 30', tag: 'Launch & Ramp', views: 33744, posts: 69, note: 'Network built: 11 accounts, 3 personas, recycling pipeline live' },
    { label: 'May', tag: 'The Breakout', views: 675645, posts: 393, note: 'Unseen persona goes viral — the network catches fire' },
    { label: 'June', tag: 'Volume Engine', views: 418724, posts: 818, note: 'Output more than doubles; views compound across pages' },
    { label: 'Jul 1–7', tag: 'Current Pace', views: 53238, posts: 228, note: 'One week — tracking toward the biggest volume month yet' },
];

// Phase 2 proposal — plans and projections, not measured results.
export const PHASE2 = {
    pillars: [
        {
            title: '+2 New Fan Pages',
            body: 'Two fresh personas on the proven incubation playbook — 5 fan personas across 3 platforms, every one feeding the main brand.',
        },
        {
            title: '7 Posts / Day Per Page',
            body: 'The 90-episode backlog and recycling pipeline are already built. The content exists — Phase 2 opens the throttle on distribution.',
        },
        {
            title: 'More Original Videos',
            body: 'Scale fresh recordings on the main page alongside the recycled network volume, so the flagship compounds while the network multiplies reach.',
        },
    ],
    volumeMath: {
        currentPostsPerMonth: 820,
        phase2PostsPerMonth: 1900,
        note: 'June measured 818 posts. Phase 2 projection: 5 fan pages at 7/day plus current main-page cadence. Volume is the input we control — views follow the network’s measured average.',
    },
};

export const formatNum = (n) => {
    if (n === null || n === undefined) return '—';
    return n.toLocaleString();
};
